import { MultipleBanner } from './index.types'

export const MAX_COL = 4
export const ratioByCol: {
  [key in MultipleBanner['layout']]: Record<number, number> // height / width
} = {
  image_overlay_button: {
    2: 400 / 552,
    3: 400 / 360,
    4: 400 / 264,
  },
  image_on_top_button_below: {
    2: 220 / 552,
    3: 200 / 360,
    4: 200 / 264,
  },
}
